import { jsx as _jsx } from "react/jsx-runtime";
export default function ExternalLinkIcon(_ref) {
  var color = _ref.color;
  return /*#__PURE__*/_jsx("svg", {
    width: "13",
    height: "12",
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.4932 1.049C12.4932 0.5 12.0493 0.053 11.4993 0.05L3.50625 0H3.50025C2.95025 0 2.50425 0.444 2.50025 0.994C2.49625 1.546 2.94125 1.997 3.49425 2L9.05225 2.035L0.79325 10.293C0.40225 10.684 0.40225 11.317 0.79325 11.707C0.98825 11.903 1.24425 12 1.50025 12C1.75625 12 2.01225 11.903 2.20725 11.707L10.4952 3.419L10.5002 9.001C10.5002 9.553 10.9482 10 11.5002 10H11.5013C12.0533 10 12.5002 9.551 12.5002 8.999L12.4932 1.049Z",
      fill: color ? color : 'white'
    })
  });
}